<template>
    <p>logout</p>
</template>

<script>
export default {
    name: "Logout",
    //==================================================
    created: function () {
        this.logout();
    },
    //==================================================
    methods: {
        logout: function () {
            this.$localStorage.set("autoLogin", 0);
            this.$localStorage.remove("user-jwt");
            this.$router.push({ path: "/login" });
        },
    },
    //==================================================
};
</script>
